/* eslint-disable camelcase */
import React from 'react'
import Img from 'gatsby-image'

import { graphql } from 'gatsby'
import styled from 'styled-components'

import { Container } from 'reactstrap'
import SEO from '../components/SEO'
import Layout from '../components/layout'
import formatMoney from '../utils/formatMoney'

const StyledService = styled.div`
  .container img {
    max-width: 100%;
  }
  .serviceDescription {
    max-width: 45em;
  }
  .embed-responsive {
    max-width: 400px;
  }
  .headerContainer {
    margin-top: 20px;
    .gatsby-image-wrapper {
      max-height: 250px;
    }
  }
  h1 {
    margin-top: 20px;
  }
  .services {
    h2 {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
        'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
        'Noto Color Emoji';
      font-size: 20px !important;
      margin-right: 10px;
    }
    .price {
      font-size: 18px;
      font-family: 'Kalam';
      font-weight: 500;
    }
    img {
      max-height: 200px;
      height: auto;
    }
  }
`

const service = ({ data, location }) => {
  const {
    naam,
    hoofdafbeelding,
    childContentfulCategorieOmschrijvingTextNode,
    contentful_id,
    dienst,
    meta,
  } = data.contentfulCategorie

  let hasPrice = false
  if (dienst) {
    for (let index = 0; index < dienst.length; index += 1) {
      const element = dienst[index]
      if (element.prijs) {
        hasPrice = true
      }
    }
  }

  return (
    <Layout>
      <SEO title={naam} path={location.pathname} description={meta} />
      <StyledService>
        <Container>
          {hoofdafbeelding && (
            <div className="headerContainer">
              <Img fluid={hoofdafbeelding.fluid} />
            </div>
          )}
          <Container>
            <h1>{naam}</h1>
            {childContentfulCategorieOmschrijvingTextNode && (
              <div
                className="serviceDescription"
                dangerouslySetInnerHTML={{
                  __html: childContentfulCategorieOmschrijvingTextNode.childMarkdownRemark.html,
                }}
              />
            )}
            <div className="services">
              {dienst &&
                dienst
                  .sort((prev, next) =>
                    new Date(prev.updatedAt) < new Date(next.updatedAt) ? 0 : -1
                  )
                  .map(dnst => (
                    <div key={`${dnst.naam}-${contentful_id}`} className="mt-4">
                      <div className="d-flex justify-content-between">
                        <h2 className="text-dark">{dnst.naam}</h2>
                        <span className="price">
                          {dnst.prijs && formatMoney(dnst.prijs)}
                          {dnst.prijs2 && ` / ${formatMoney(dnst.prijs2)}`}
                        </span>
                      </div>
                      {dnst.omschrijving && (
                        <div
                          className="serviceDescription"
                          dangerouslySetInnerHTML={{
                            __html: dnst.omschrijving.childMarkdownRemark.html,
                          }}
                        />
                      )}
                    </div>
                  ))}
            </div>
            {hasPrice && (
              <p className="text-center mt-5" style={{ fontSize: '14px' }}>
                Prijzen onder voorbehoud van prijswijzigingen. <br /> Contacteer ons voor de meest
                actuele prijzen.
              </p>
            )}
          </Container>
        </Container>
      </StyledService>
    </Layout>
  )
}

export default service

export const query = graphql`
  query($contentful_id: String!) {
    contentfulCategorie(contentful_id: { eq: $contentful_id }) {
      naam
      meta
      childContentfulCategorieOmschrijvingTextNode {
        childMarkdownRemark {
          html
        }
      }
      hoofdafbeelding {
        fluid {
          ...GatsbyContentfulFluid_noBase64
        }
      }
      contentful_id
      dienst {
        updatedAt
        naam
        prijs
        prijs2
        omschrijving {
          id
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`
